import { motion } from "framer-motion";
import { MenuSquare, Instagram, CreditCard, PackageCheck, CalendarClock, PartyPopper } from "lucide-react";
import { BUSINESS } from "@/lib/business";

const STEPS = [
  { icon: MenuSquare, title: "Browse the menu", text: "Explore our Iraqi & Middle Eastern mains, sides, breads, and desserts." },
  { icon: Instagram, title: "Send your order", text: `Order right here on the site, or message us on Instagram @${BUSINESS.instagram}.` },
  { icon: CreditCard, title: "Pay your way", text: "Cash App, Apple Pay, or cash at pickup." },
  { icon: PackageCheck, title: "Pickup your order", text: "We'll confirm your pickup time and details, then get cooking!" },
];

export const HowToOrder = () => {
  return (
    <section id="how" data-testid="how-to-order" className="py-20 sm:py-28 bg-surface2">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-sm tracking-[0.25em] uppercase text-brand font-bold">How to Order</span>
          <h2 className="mt-3 font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-ink">
            Ordering is simple
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              data-testid={`order-step-${i + 1}`}
              className="bg-white p-8 rounded-3xl border border-line text-center relative"
            >
              <span className="absolute -top-4 left-1/2 -translate-x-1/2 font-serif text-sm font-bold bg-brand text-white w-9 h-9 flex items-center justify-center rounded-full">
                {i + 1}
              </span>
              <div className="w-14 h-14 mx-auto rounded-2xl bg-brand/10 flex items-center justify-center text-brand mt-2">
                <s.icon size={26} />
              </div>
              <h3 className="mt-5 font-serif text-lg font-semibold text-ink">{s.title}</h3>
              <p className="mt-2 text-sm text-inkmuted">{s.text}</p>
            </motion.div>
          ))}
        </div>

        <div data-testid="how-advance-notice" className="mt-10 grid sm:grid-cols-2 gap-4 max-w-4xl mx-auto">
          <div className="flex items-center gap-3 bg-gold/15 border border-gold/40 rounded-2xl px-6 py-4 text-left">
            <CalendarClock className="text-brand shrink-0" size={22} />
            <p className="text-ink font-semibold text-sm">
              Please order <span className="text-brand">at least 2 days in advance</span> so we can prepare everything fresh.
            </p>
          </div>
          <div data-testid="how-catering-notice" className="flex items-center gap-3 bg-brand/10 border border-brand/30 rounded-2xl px-6 py-4 text-left">
            <PartyPopper className="text-brand shrink-0" size={22} />
            <p className="text-ink font-semibold text-sm">
              Catering for parties &amp; weddings? Please order <span className="text-brand">at least 1 week ahead</span>.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
